module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/25d9035005e6a4833dbb463da19ec139.gif";